const PopupInit = () => {
  const body: HTMLBodyElement = document.querySelector('body');
  const sizeChartOpen: HTMLElement = document.querySelector('.size-chart__toggler');
  const sizeChartPopup: HTMLElement = document.querySelector('.size-chart__popup');
  const sizeChartPanels: NodeListOf<HTMLElement> = sizeChartPopup.querySelectorAll('.size-chart__panel');
  const sizeChartOverlay: HTMLElement = document.querySelector('.size-chart__overlay');
  const sizeChartClose: HTMLElement = document.querySelector('.size-chart__close');
  const activeClassPanel = 'panel--active';
  const activeClassPopup = 'size-chart__popup--active';
  const activeClassOverlay = 'size-chart__overlay--active';

  const firstHeader = sizeChartPanels[0].querySelector('.size-chart__panel-header') as HTMLElement;
  const firstContent = sizeChartPanels[0].querySelector('.size-chart__panel-content') as HTMLElement;
  const firstContentInner = sizeChartPanels[0].querySelector('.size-chart__panel-inner') as HTMLElement;
  const firstIcon = firstHeader.lastElementChild;

  sizeChartOpen.addEventListener('click', () => {
    // Add padding to the bottom of the popup

    // Open the first tab of the sizecharts
    setTimeout(() => {
      const firstPanelHeight = firstContentInner.offsetHeight + 16;
      sizeChartPanels[0].classList.add(activeClassPanel);
      firstContent.style.maxHeight = `${firstPanelHeight}px`;
      firstIcon.classList.remove('fa-angle-down');
      firstIcon.classList.add('fa-angle-up');
    }, 300);

    // Open the sizechart popup
    sizeChartPopup.classList.add(activeClassPopup);
    sizeChartOverlay.classList.add(activeClassOverlay);
    body.classList.add('fixed-body');
    if (sizeChartOverlay.classList[1] === activeClassOverlay) {
      sizeChartOverlay.addEventListener('click', () => {
        sizeChartPopup.classList.remove(activeClassPopup);
        sizeChartOverlay.classList.remove(activeClassOverlay);
        body.classList.remove('fixed-body');
      });
    }
  });

  sizeChartClose.addEventListener('click', () => {
    sizeChartPopup.classList.remove(activeClassPopup);
    sizeChartOverlay.classList.remove(activeClassOverlay);
    body.classList.remove('fixed-body');
  });

  // size-chart accordion logic
  const panelContents: NodeListOf<HTMLElement> = document.querySelectorAll('.size-chart__panel-content');

  const closeAccordions = () => {
    sizeChartPanels.forEach((panel: HTMLElement) => {
      panel.classList.remove(activeClassPanel);
    });
    panelContents.forEach((content: HTMLElement) => {
      const innerContent = content;
      innerContent.style.maxHeight = '0px';
    });
  };

  sizeChartPanels.forEach((panel: HTMLElement) => {
    const title = panel.querySelector('.size-chart__panel-header') as HTMLElement;
    const content = panel.querySelector('.size-chart__panel-content') as HTMLElement;
    const contentInner = panel.querySelector('.size-chart__panel-inner') as HTMLElement;
    const icon = title.lastElementChild;

    title.addEventListener('click', () => {
      const panelHeight = contentInner.offsetHeight + 16;

      if (panel.classList.contains(activeClassPanel)) {
        panel.classList.remove(activeClassPanel);
        contentInner.style.maxHeight = `${panelHeight}px`;
        content.style.maxHeight = '0px';
        icon.classList.remove('fa-angle-up');
        icon.classList.add('fa-angle-down');
      } else {
        closeAccordions();
        panel.classList.add(activeClassPanel);
        content.style.maxHeight = `${panelHeight}px`;
        icon.classList.remove('fa-angle-down');
        icon.classList.add('fa-angle-up');
      }
    });
  });
};

export default PopupInit;
